export {default as BeWizrMiscItemDocument} from './BeWizrMiscItemDocument'